import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCake = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-cake-icon lucide-cake",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 21h20" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 8v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 8v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 8v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 4h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 4h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 4h.01" })
	]
});
export default SvgCake;
